import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./gridConfig";
import GridHeader from "../../../components/GridHeader";
import StatusBar from '@dataGrid/components/StatusBar';

const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .ag-theme-material .ag-icon-checkbox-checked": {
      color: theme.HeaderSelectedText,
    },
    "& .ag-theme-material .checkBoxHeader": {
      display : "flex",
      paddingLeft : 24
    },
    [`& .gridTheme-${theme.themeName}`]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  gridContent: {
    borderColor: theme.AppBGColor,
    borderStyle: "solid",
    borderWidth: "1px",
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
});
class TrapBillsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig();
  }

  componentDidMount() {
    this.props.glEventHub.on("trapBillsGrid", this.onSearchTextChanged);
  }

  componentWillUnmount() {
    this.props.glEventHub.off("trapBillsGrid", this.onSearchTextChanged);
  }

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Total Bills",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, ...rest } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="Trap Bills"
          headerId="trapBillsGrid"
          glEventHub={this.props.glEventHub}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          suppressRowClickSelection
          quickFilterText={this.state.searchText}
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          {...rest}
        />
      </div>
    );
  }
}

export default withStyles(styles)(TrapBillsGrid);
